import { useState }             from 'react';
import { connect }              from 'react-redux';
import { Dispatch }             from "redux";
import { ActionTypes }          from 'actions/types';
import { colors }               from 'utils/colors';
import { makeStyles }           from 'makeStyles';
import { UPDATE_APPROVED_SAGA } from 'actions/zviActions';


const useStyles = makeStyles()(() => ({
    root: {
     // position:         'absolute',
      display:          'flex',
      flexFlow:         'column',
      alignItems:       'center',
      justifyContent:   'center',
      height:           '100%',
      width:            '100%',
      backgroundColor:  '#FFF',
    },
    button: {
        background:       colors.primary,
        display:          'flex',
        alignItems:       'center',
        justifyContent:   'center',
        color:            '#FFF',
        width:            200,
        marginTop:        5,
        height:           30
    }
}))

type ModalProps = {
    id:                   number;
    approved:             string;
    setShowApprovedModal: (val: boolean) => void;
    submit:               (payload: { id: number, newVal: string }) => void;
}

const Modal: React.FC<ModalProps> = ({
    id,
    approved,
    setShowApprovedModal,
    submit
}) => {

  const { classes } = useStyles();

  const [newVal, setNewVal] = useState("")

  const changeInputValue = (e: React.FormEvent) => {

    e.preventDefault();

    const target = e.target as HTMLInputElement;

    setNewVal(target.value)
    
  }

  const handleClose = () => {
    setNewVal('')
    setShowApprovedModal(false)
  }

  const handleSubmit = () => {
    if (newVal === '') {
      return
    }
    submit({ id: id, newVal: newVal })
    handleClose();
  }

  return (
    <div className = { classes.root }>
         <input
            type         = "text"
            id           = "approved"
            placeholder  = { approved }
            onChange     = { changeInputValue }
            autoComplete = "off"
         />
         <div 
           className = { classes.button }
           onClick   = { handleSubmit }
         >
               submit
         </div>
         <div 
           className = { classes.button }
           onClick   = { handleClose }
         >
             close
         </div>
    </div>
  );
}



const mapStateToProps = () => {
    return {
  }};
  
  const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
    submit: (payload: { id: number, newVal: string }) => dispatch(UPDATE_APPROVED_SAGA(payload))
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(Modal);